import { Link } from 'react-router-dom';
import { ChevronRight, PackageSearch } from 'lucide-react';

export function LostAndFoundShortcut({ compact = false }: { compact?: boolean }) {
  return (
    <Link
      to="/dashboard/lost-found"
      className="group focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal-400"
      style={{
        display: compact ? 'inline-flex' : 'flex', alignItems: 'center', gap: compact ? 6 : 12,
        padding: compact ? '5px 0' : '14px 16px', marginTop: compact ? 6 : 0,
        borderRadius: compact ? 4 : 12, textDecoration: 'none',
        background: compact ? 'transparent' : 'rgba(20,184,166,.07)',
        border: compact ? 'none' : '1px solid rgba(20,184,166,.18)',
        color: '#14B8A6', fontFamily: "'Outfit',sans-serif", fontSize: compact ? 11 : 13,
      }}
    >
      <PackageSearch size={compact ? 14 : 20} aria-hidden style={{ flexShrink: 0 }} />
      <span style={{ flex: compact ? undefined : 1, minWidth: 0 }}>
        <span style={{ display: 'block', fontWeight: 500 }}>Lost &amp; Found</span>
        {!compact && (
          <span style={{ display: 'block', color: 'rgba(255,255,255,.5)', fontSize: 11, marginTop: 3 }}>
            Post a missing item or help return a find.
          </span>
        )}
      </span>
      <ChevronRight size={compact ? 12 : 16} aria-hidden className="transition-transform group-hover:translate-x-0.5" style={{ flexShrink: 0 }} />
    </Link>
  );
}
